import ProfileItem from "./profile";
import { Profile } from "../Types";

const Profiles = ({ 
    profiles, 
    currentProfile, 
    handleProfileSwitch, 
    handleAddProfile, 
    handleEditProfile,
    uploadedProfile
}:{ 
    profiles: Profile[], 
    currentProfile: number, 
    handleProfileSwitch: Function, 
    handleAddProfile: Function, 
    handleEditProfile: Function,
    uploadedProfile: string
}) => {
    const emptyProfiles = Array.from({ length: 4 - profiles.length }, (_, index) => (
        {id: 0, name: "NEW PROFILE", settings: {}, steady_modes: [], flash_modes: []}
    ));

    return (
        <div className="profile-container">
            {profiles.map((profile, index) => (
                <ProfileItem
                    key={index}
                    profile={profile}
                    active={profile.id === currentProfile}
                    onProfileClick={() => handleProfileSwitch(profile.id)}
                    onProfileEdit={() => handleEditProfile(profile.id)}
                    uploadedProfile={uploadedProfile}
                />
            ))}
            {profiles.length < 4 &&
                emptyProfiles.map((profile, index) => (
                    <ProfileItem
                        key={index}
                        profile={profile}
                        onProfileClick={handleAddProfile}
                    />
            ))}
        </div>
    );
}

export default Profiles;